import { useState } from 'react';

import { Languages } from '../../../constants/languages';

export const useLanguageContextConnector = () => {
  const [language, setLanguage] = useState<Languages>(Languages.EN_GB);

  return { language, setLanguage };
};
